import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '.'

export type AlertType = 'error' | 'success'

interface AlertState {
  show: boolean
  message: string | { title: string; description: string }
  type: AlertType
}

const initialState: AlertState = {
  show: false,
  message: '',
  type: 'error',
}

export const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setShowAlert: (state, action: PayloadAction<boolean | string | Omit<AlertState, 'show'>>) => {
      const show: boolean | string | Omit<AlertState, 'show'> = action.payload
      if (typeof show === 'string') {
        state.show = true
        state.message = show
        state.type = 'error'
      } else if (typeof show === 'boolean') {
        state.show = show
        state.message = ''
        state.type = 'error'
      } else {
        state.show = true
        state.message = show.message
        state.type = show.type
      }
    },
  },
})

export const { setShowAlert } = alertSlice.actions

export const selectAlert = (state: RootState) => state.alert

export default alertSlice.reducer
